module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.BACKLOG_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3006' : envUrl;

          if (true && isDev) {
            console.error('[Module Federation] BACKLOG_URL not configured for production');
            reject(new Error('Backlog MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.backlog);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load backlog remote from:', remoteUrl);
            reject(new Error('Failed to load Backlog MFE'));
          };
          document.head.appendChild(script);
        });